if (typeof window.initAddToCartListeners !== 'function') {
  window.initAddToCartListeners = function() {
    // Sécurité : ne rien faire si le drawer n’est pas dans le DOM
    const cartDrawerEl = document.querySelector('cart-drawer');
    const cartDrawerDiv = document.getElementById('CartDrawer');
    if (!cartDrawerEl || !cartDrawerDiv) {
      console.warn('[initAddToCartListeners] Appelé trop tôt : drawer absent du DOM. Listeners NON attachés.');
      return;
    }
  // 1. Boutons de suppression dans le drawer
  // 1. Après chaque update du drawer, on réattache les listeners sur les boutons supprimer
  const removeBtns = document.querySelectorAll('button.cart-remove-button');
  if (!removeBtns.length) {
    console.warn('[initAddToCartListeners] Aucun bouton supprimer trouvé après update DOM');
  }
  removeBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) {
        console.error('[initAddToCartListeners] Bouton supprimer sans data-variant-id');
        return;
      }
      fetch(`/cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      })
      .then(res => res.json())
      .then(() => {
        window.cartDrawer = document.querySelector('cart-drawer');
        if (window.cartDrawer && typeof window.cartDrawer.renderContents === 'function') {
          fetch('/?section_id=cart-drawer')
            .then(r => r.text())
            .then(html => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const cartDrawerHTML = doc.querySelector('#CartDrawer')?.outerHTML || '';
              if (!cartDrawerHTML) {
                console.error('[initAddToCartListeners] ERREUR : HTML du drawer vide après suppression. Pas d’appel à renderContents.');
                return;
              }
              const parsedState = {
                sections: { 'cart-drawer': cartDrawerHTML }
              };
              // On laisse cart-drawer.js gérer la réinitialisation des listeners après le render
              window.cartDrawer.renderContents(parsedState);
            });
        } else {
          console.error('[initAddToCartListeners] ERREUR : window.cartDrawer absent ou renderContents non disponible après suppression');
        }
      });
    });
  });
  // 2. Boutons de quantité dans le drawer
  document.querySelectorAll('.quantity__input').forEach(function(input) {
    input.addEventListener('change', function(e) {
      e.preventDefault();
      const variantId = input.getAttribute('data-quantity-variant-id');
      const quantity = parseInt(input.value, 10);
      if (!variantId || isNaN(quantity)) return;
      fetch(`/cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(res => res.json())
      .then(() => {
        if (window.cartDrawer && typeof window.cartDrawer.renderContents === 'function') {
          fetch('/?section_id=cart-drawer')
            .then(r => r.text())
            .then(html => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const parsedState = {
                sections: { 'cart-drawer': doc.querySelector('#CartDrawer')?.outerHTML || '' }
              };
              window.cartDrawer.renderContents(parsedState);
            });
        }
      });
    });
  });
  // 3. Log pour debug
  console.log('initAddToCartListeners : Listeners réattachés (drawer)');
};
}
